import React, { useState, useContext, useEffect }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent, IonModal, IonText  } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { helpCircleOutline, menuOutline } from 'ionicons/icons';

//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
//import { App_Footer } from '../components/App_Footer';

import '../../../css/layout.css';


import { useHistory} from "react-router-dom";

 export function Modal_UpdateDeliveryFee (props) {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authMerchant_objects.acctID);
    let [employeeID, setEmployeeID ] = useState(authMerchant_objects.employeeID);
    let [schema, setSchema ] = useState(authMerchant_objects.schema);
    let [access, setAccessRights ] = useState(authMerchant_objects.accessRights);
    let [sessionID, setSessionID ] = useState(authMerchant_objects.sessionID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);


    let [deliveryFeeID, setDeliveryFeeID] = useState(props.data.deliveryFeeID);
    let [itemID, setItemID] = useState(props.data.itemID);
    let [deliveryAmount, setDeliveryAmount] = useState(props.data.deliveryAmount);
    let [deliveryCity, setDeliveryCity] = useState(props.data.deliveryCity);
    let [deliveryCityDistrict, setDeliveryCityDistrict] = useState(props.data.deliveryCityDistrict);
    let [deliveryRegion, setDeliveryRegion] = useState(props.data.deliveryRegion);
    let [deliveryCountry, setDeliveryCountry] = useState(props.data.deliveryCountry);
    let [updatedeliveryFeeModal, setUpdateDeliveryFeeModal] = useState(props.openModal);

    let [saveDisabled, setSaveDisabled] = useState(false);

    const isInvalid = (v) => ['', 'null', 'NULL', 'undefined'].includes(v);

    let history = useHistory();
    let router = useIonRouter();



function submit_updateDeliveryFee()
{
    setSaveDisabled(true);

    let formData = new FormData();
    formData.append('Tracker', '33_delivery_fee_list_update');
    formData.append('user', acctID);
    formData.append('merchantSchema', schema);
    formData.append('xDeliveryFeeID', deliveryFeeID);
    formData.append('xDeliveryFeeItemID', itemID);
    formData.append('xDeliveryFeeAmount', deliveryAmount);
    formData.append('xDeliveryFeeCity', deliveryCity);
    formData.append('xDeliveryFeeCityDistrict', deliveryCityDistrict)
    formData.append('xDeliveryFeeRegion', deliveryRegion);
    formData.append('xDeliveryFeeCountry', deliveryCountry);
    //formData.append('xImageFile', selectedFile);
    formData.append('sessionID', sessionID);

    const requestOptions = {
        enctype: 'multipart/form-data',
        method:'POST',
        credentials: 'include',
        files: formData,
        body: formData,
        contentType: false,
        processData: false,
    }


    fetch(baseURL+'retail_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(res => {

        alert(res);
        setSaveDisabled(false);
        
        props.closeModal();
    })
}



    return (
            <React.Fragment>
                        <IonModal isOpen={ props.openModal }>
                            <IonHeader>
                                <IonToolbar>
                                <IonTitle>{"FEE INFO"}</IonTitle>
                                <IonButtons slot="end">
                                    <IonButton fill="outline" color="success" onClick={() => props.closeModal()}>Close</IonButton>
                                </IonButtons>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent className='grid_content'>
                            <IonGrid>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Delivery Amount: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(deliveryAmount) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={deliveryAmount} placeholder='Enter Company Name' autocomplete='off' onIonChange={(e) => setDeliveryAmount(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Delivery City: </h5>
                                        </IonCol>y
                                        <IonCol size='6'>
                                            <IonInput className={'professional-input input-valid'} type='text' value={deliveryCity} placeholder='Enter Address Number' autocomplete='off' onIonChange={(e) => setDeliveryCity(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >City District: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={'professional-input input-valid'} type='text' value={deliveryCityDistrict} placeholder='Enter District' autocomplete='off' onIonChange={(e) => setDeliveryCityDistrict(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                   <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Region: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(deliveryRegion) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={deliveryRegion} placeholder='Enter MTGN Phone' autocomplete='off' onIonChange={(e) => setDeliveryRegion(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol size='6'>
                                            <h5 >Country: </h5>
                                        </IonCol>
                                        <IonCol size='6'>
                                            <IonInput className={isInvalid(deliveryCountry) ? 'professional-input input-invalid' : 'professional-input input-valid'} type='text' value={deliveryCountry} placeholder='Enter MTGN Phone' autocomplete='off' onIonChange={(e) => setDeliveryCountry(e.target.value)} required></IonInput>
                                        </IonCol>
                                    </IonRow>
                            </IonGrid>
                            </IonContent>
                            <IonFooter className='grid_footer'>
                                <IonGrid>
                                    <IonRow>
                                        <IonCol size='12'>
                                            <IonButton disabled={saveDisabled} onClick={() => submit_updateDeliveryFee()}>Save</IonButton>
                                        </IonCol>
                                    </IonRow>
                                </IonGrid>
                            </IonFooter>
                        </IonModal>
            </React.Fragment>

    );
};



export default Modal_UpdateDeliveryFee;